import React, { useState, useEffect } from 'react';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../../components/Modal/Modal';
import TextField from '../../../components/TextField/TextField';
import Loading from '../../../components/Loading/Loading';

//Api
import tiposImplemento_api from '../../../api/tiposImplemento_api';
import modalidadeColeta_api from '../../../api/modalidadeColeta_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import { validarCampos, objCampo } from '../../../helpers/ValidadorDeCampos';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Estado inicial do implemento
function initialStateImplemento() {
    return {
        descricao: "",
        status: "Ativo",
        modalidades: [],
    }
}
export default function TiposImplemento({ permissao }) {
    //Controle do modal de cadastro/edição
    const [openModal, setOpenModal] = useState(false);

    //Controle dos dados de cadastro/edição do implemento
    const [implemento, setImplemento] = useState(initialStateImplemento);

    //Salva todas as opções de modaliades possiveis para o cadastro/edição
    const [optionsModalidades, setOptionsModalidades] = useState([]);

    //Salva todas opções de implementos possiveis para o cadastro/edição
    const [tiposDeImplementos, setTiposDeImplementos] = useState([]);

    //Controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Controle dos erros nos campos obrigatorios
    const [errors, setErrors] = useState({});

    //Campos obrigatorios do cadastro/edição
    const campos = [objCampo({ name: "descricao", required: true }), objCampo({ name: "modalidades", required: true })];

    //Troca do estado do modal
    const toggleModal = () => {
        if (openModal) {
            setImplemento(initialStateImplemento);
            setErrors({});
        }
        setOpenModal(!openModal);
    };

    //Change para os campos do implemento
    const onChangeImplemento = (e, select) => {
        if (select && select.name) {
            const _implemento = {
                ...implemento,
                [select.name]: e
            }
            const campo = campos.filter(c => c.name == select.name);
            const erros = validarCampos(_implemento, campo);
            if (erros[1].length == 0) {
                const _errors = { ...errors };
                delete _errors[select.name];

                setErrors(_errors);
            } else {
                setErrors({ ...errors, ...erros[0] })
            }
            setImplemento(_implemento);
        } else {
            const { name, value } = e.target;
            const _implemento = {
                ...implemento,
                [name]: value
            };
            const campo = campos.filter(c => c.name == name);
            const erros = validarCampos(_implemento, campo);
            if (erros[1].length == 0) {
                const _errors = { ...errors };
                delete _errors[name];

                setErrors(_errors);
            } else {
                setErrors({ ...errors, ...erros[0] })
            }
            setImplemento(_implemento);

        }
    }

    //Carrega todos os implementos e salva no estado
    const loadImplementos = () => {
        setLoading(true);
        tiposImplemento_api.GetList().then(response => {
            setTiposDeImplementos(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    //Carrega os implementos e as modalidades de coleta assim que o componente é iniciado
    useEffect(() => {
        loadImplementos();
        modalidadeColeta_api.GetList().then(response => {
            const _options = [];
            response.data.map(modalidade => {
                _options.push({ label: modalidade.descricao, value: modalidade.id });
            })
            setOptionsModalidades(_options);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        })
    }, []);

    //Adiciona/Edita um implemento
    const addNovoImplemento = () => {
        const erros = validarCampos(implemento, campos);
        setErrors(erros[0]);
        if (erros[1].length > 0) {
            return;
        }
        setLoading(true);
        const _implemento = {
            ...implemento,
            modalidades: implemento.modalidades.map(m => m.value)
        }

        if (implemento.id) {
            tiposImplemento_api.Put(_implemento).then(response => {
                showMessage("Sucesso", "Sucesso ao atualizar o implemento", "success");
                setImplemento(initialStateImplemento);
                toggleModal();
                loadImplementos();
            }).catch(e => showMessage("Aviso", e.message, "error", null))
                .finally(f => setLoading(false));
        } else {
            tiposImplemento_api.Post(_implemento).then(response => {
                showMessage("Sucesso", "Sucesso ao adicionar o novo implemento", "success");
                setImplemento(initialStateImplemento);
                toggleModal();
                loadImplementos();
            }).catch(e => showMessage("Aviso", e.message, "error", null))
                .finally(f => setLoading(false));
        }
    }

    //Salva os dados necessarios para a edição do implemento
    const editarImplemento = (item) => {
        tiposImplemento_api.GetItem(item.id).then(response => {
            response.data.modalidades = response.data.modalidades.map(idModalidade => { return optionsModalidades.filter(v => v.value === idModalidade)[0] });
            setImplemento(response.data);

        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
        toggleModal();
    }

    //Ações da tabela de listagem
    const actions = [];
    if (permissao === "Editar")
        actions.push(actionsTable.editar(editarImplemento));

    //Cabeçalhos da tabela do tipo de implemento
    const headers = [
        { value: "Identificação", objectValue: "descricao", align: "left" },
        { value: "Status", objectValue: "status", align: "left" },
        { value: "Modalidades", objectValue: "modalidades", align: "left" }
    ]

    return (
        <>
            {loading && <Loading />}
            <MainCard noCard btnCadastro={permissao === "Editar" ? "Adicionar" : null} onClickBtnCadastro={toggleModal}>

                <ModalCustomized isOpen={openModal} toggle={toggleModal} title={implemento.id ? <><FontAwesomeIcon icon={faEdit} /> Editar implemento</> : "Novo tipo de implemento"} btnAction={implemento.id ? <><FontAwesomeIcon icon={faEdit} /> Editar</> : "+ Adicionar"} onClickBtnAction={addNovoImplemento} btnActionColor={implemento.id ? "warning text-light" : "success"} btnClose>
                    <Row>
                        <Row className='mb-4'>
                            <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
                        </Row>
                        <Col md="12" lg="6">
                            <TextField maxLength={100} invalid={errors.descricao ? true : false} name="descricao" label="* Identificação" value={implemento.descricao} onChange={onChangeImplemento} />
                            {errors.descricao && <span className={"form-control-label text-danger"}>{errors.descricao.message}</span>}
                        </Col>
                        <Col md="12" lg="6">
                            <TextField name="status" label="Status" type={"select"} options={[{ text: "Ativo", value: "Ativo" }, { text: "Inativo", value: "Inativo" }]} value={implemento.status} onChange={onChangeImplemento} />
                        </Col>

                    </Row>
                    <Row>

                        <Col md="12" lg="12">
                            <TextField invalid={errors.modalidades ? true : false} name="modalidades" label="* Modalidades de Coleta" multiple type={"select"} options={optionsModalidades} value={implemento.modalidades} onChange={onChangeImplemento} />
                            {errors.modalidades && <span className={"form-control-label text-danger"}>{errors.modalidades.message}</span>}
                        </Col>

                    </Row>
                </ModalCustomized>
                <div className="mt-4">
                    <TabelaListagem actions={actions} title={"Lista de implementos"} options={{ print: false, search: true, pagination: true }} headers={headers} items={tiposDeImplementos} />
                </div>
            </MainCard>
        </>
    )
}